import React from 'react';
import { Placeholder, Spinner } from 'react-bootstrap';

interface ProjectLoadingStateProps {
  message?: string;
  compact?: boolean;
}

const ProjectLoadingState: React.FC<ProjectLoadingStateProps> = ({ message, compact = false }) => (
  <div className={`project-loading-state ${compact ? 'project-loading-state--compact' : ''}`.trim()}>
    <div className="d-flex align-items-center gap-2 mb-2">
      <Spinner animation="border" size="sm" />
      <span className="small text-muted">{message || 'Carregando dados...'}</span>
    </div>
    <Placeholder as="p" animation="glow" className="mb-1">
      <Placeholder xs={12} />
    </Placeholder>
    <Placeholder as="p" animation="glow" className="mb-1">
      <Placeholder xs={10} />
    </Placeholder>
    <Placeholder as="p" animation="glow" className="mb-0">
      <Placeholder xs={8} />
    </Placeholder>
  </div>
);

export default ProjectLoadingState;
